import { useConnect } from '@stacks/connect-react';
import React from 'react';
import { authenticatedUserAddress, network } from '../../services/auth';
import { clientNetwork } from '../../lib/constants';
import { AnchorMode, listCV, uintCV } from '@stacks/transactions';
import { Button } from '@mui/material';
import { getDeruptCoreContractPrivately } from '../../services/chime';

const ClaimLongListButton = ({ longList, setConfirmTx, setShowConfirmModal }) => {
    const { doContractCall } = useConnect();

    const claimList = async () => {
        const userAddress = authenticatedUserAddress({ network: clientNetwork });
        const coreAddress = await getDeruptCoreContractPrivately();
        if (!coreAddress) return;

        doContractCall({
            contractAddress: coreAddress.split('.')[0],
            contractName: coreAddress.split('.')[1],
            functionName: 'claim-mining-reward-list',
            functionArgs: [listCV(longList.map(block => uintCV(block)))],
            network: network({ network: clientNetwork }),
            stxAddress: userAddress,
            anchorMode: AnchorMode.Any,
            onFinish: ({ txId }) => {
                setConfirmTx(txId);
                setShowConfirmModal(true);
            },
            onCancel: () => {
                console.log("Action cancelled");
            }
        });
    };

    return (
        <div className='claimlonglist'>
            <Button sx={{ backgroundColor: '#f7931a' }} variant='contained' onClick={claimList}>Claim List {`(${longList.length}/200)`}</Button>
        </div>
    );
};

export default ClaimLongListButton;